module.exports = __webpack_public_path__ + "media/img/specialize/item3-149ed54a6c594111101244e7eaa7f9b8.svg";